export default {
  "fontElementMap": "li5CU",
  "elementSpacing": "Vmlgg",
  "text": "S1KXg Vmlgg",
  "child": "KS6-G"
};